import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import SendNotification from "../../components/Notification/SendNotification";


const AddNotification = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb  id="title" title2="Notification" link2="/notification" title="Send Notification" />

        {/* UsersListLayer */}
        <SendNotification />

      </MasterLayout>

    </>
  );
};

export default AddNotification; 
